// A presentation timeout does not cancel the account handoff. Reopening signup
// or retrying while it is still running must join the same request.
export const createOnboardingSaveCoordinator = () => {
    const requests = new Map();
    return (key, operation) => {
        if (requests.has(key)) return requests.get(key);
        const request = Promise.resolve().then(operation).finally(() => {
            if (requests.get(key) === request) requests.delete(key);
        });
        requests.set(key, request);
        return request;
    };
};

export const runOnboardingSaveRequest = createOnboardingSaveCoordinator();
